import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import SearchBar from "../../../../Components/Utils/SearchBar";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  ImportButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import DataTable from "../../../../Components/Others/DataTable";
import { Link, useLocation } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import AgentsTable from "./AgentsTable";
import List from "../../../../Components/Icons/list";
import Card from "../../../../Components/Icons/card";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import Select from 'react-select'
import Pagination from "../../../../Components/Utils/Pagenation";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from 'yup';
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import Importdoc from "./Importdoc";
import { GetAccess } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import useFetchMetaStarIndex from "../../../../Components/Hooks/useFetchMetaStarIndex";
import ViewToggle from "../../../../Components/Utils/ViewToggle";

function AgentIndex() {

  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { value: Type } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'AgentType', showFilterDialog)
  const { value: Rating } = useFetchMetaStarIndex(`/dropdown/dropdown-details/`, 'AgentRating', showFilterDialog)
  const { value: status } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'AgentStatus', showFilterDialog)

  const [filterProps, setFilterProps] = useState({
    type: "",
    status: "",
    ratings: "",
  });
  const [viewMode, setViewMode] = useState(localStorage.getItem("agentsViewMode") || "table");
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);

  const [searchBy, setSearchBy] = useState("all");
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    searchBy: "",
    type: "",
    status: "",
    ratings: "",
  });

  useEffect(() => {
    localStorage.setItem("agentsViewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount, viewMode])

  const clearFilter = () => {
    setParams({
      ...params, type: "",
      status: "",
      ratings: "",
    })
    setFilter(false)
    formik.values.type = ""
    formik.values.status = ""
    formik.values.ratings = ""


  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({ ...params, type: value.type, status: value.status, ratings: value.ratings })
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        type: "",
        status: "",
        ratings: "",
      });
    }
  })

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch("/agents/", params);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '33px',
      height: '33px',
      fontSize: '12px',
      minWidth: '100px',
      width: '100px',
      borderRadius: '8px',
      border: "none"
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '4px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: '4px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
  };

  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
  ];

  const handleSearch = (selectedOption) => {
    setSearchBy(selectedOption.value);

    let SearchByVal = selectedOption.value === "all" ? "" : selectedOption.value;

    setParams({
      ...params,
      searchBy: SearchByVal,
    });
  };

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  return (
    <>
      <div className="w-full h-full px-2 sm:px-4 py-2">
        <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
          <div className="w-full md:w-auto flex justify-between items-center gap-2">
            <Breadcrumb
              items={[
                {
                  name: "Shipping",
                },
                {
                  name: "Shipping Agent",
                },
              ]}
            />
            <div className="flex md:hidden items-center gap-2">
              <FilterButton handleClick={() => setShowFilterDialog(true)} />
              {filter && <FilterButton handleClick={() => clearFilter()} label="Clear" />}
              {GetAccess("agents_create") && <ImportButton handleClick={handleImportClick} />}
              {GetAccess("agents_create") && (
                <Link to="/shipping/agents/create">
                  <CreateButton label="Agents" />
                </Link>
              )}
            </div>
          </div>

          <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
            <div className="w-full md:w-auto flex items-center gap-2">
              <div className="w-28 sm:w-32 flex-shrink-0">
                <Select
                  options={searchList}
                  value={searchList.find((i) => i.value == searchBy) || ""}
                  styles={customStyles}
                  className={`text-xs capitalize 2xl:text-sm font-medium`}
                  onChange={handleSearch}
                  menuPortalTarget={document.body}
                />
              </div>
              <div className="flex-1 min-w-0 md:w-fit">
                <SearchBar
                  handleChange={(e) => {
                    setParams({ ...params, search: e.target.value, page: 1 });
                    setPage(1);
                  }}
                  value={params.search}
                />
              </div>
            </div>

            <div className="hidden md:flex items-center gap-2">
              <FilterButton handleClick={() => setShowFilterDialog(true)} />
              {filter && <FilterButton handleClick={() => clearFilter()} label="Clear" />}
            </div>

            {/* Table / Card View Toggle */}
            <ViewToggle
              viewMode={effectiveViewMode}
              onViewChange={(mode) => setViewMode(mode)}
              storageKey="agentsViewMode"
            />

            <div className="hidden md:flex items-center gap-2">
              {GetAccess("agents_create") && <ImportButton handleClick={handleImportClick} />}
              {GetAccess("agents_create") && (
                <Link to="/shipping/agents/create">
                  <CreateButton label="Agents" />
                </Link>
              )}
            </div>
          </div>
        </div>

        <AgentsTable
          data={data}
          total={totalCount}
          pageIndex={page}
          setPageIndex={setPage}
          dataCount={pageCount}
          setDataCount={setPageCount}
          searchQuery={params?.search !== "" ? params?.search : ""}
          fetcher={getData}
          dataLoading={dataLoading}
          viewMode={effectiveViewMode}
        />
        {showFilterDialog && (
          <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
            <div className="animate-scale-in w-full sm:w-[480px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
              <h2 className="text-lg font-bold text-gray-800 mb-4">Filter Agents</h2>
              <form onSubmit={formik.handleSubmit}>
                <div className="flex flex-col gap-3 mb-4">
                  <FormikSelectTwo
                    type="text"
                    label="Agent Type"
                    placeholder="Choose"
                    Options={Type}
                    formik={formik}
                    name="type"
                    width="w-full"
                  />
                  <FormikSelectTwo
                    type="text"
                    label="Ratings"
                    placeholder="Choose"
                    Options={Rating}
                    formik={formik}
                    name="ratings"
                    width="w-full"
                  />
                  <FormikSelectTwo
                    type="text"
                    label="Status"
                    placeholder="Status"
                    Options={status}
                    formik={formik}
                    name="status"
                    width="w-full"
                  />
                </div>
                <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
                  <CancelButton handleClick={closeFilterDialog} />
                  <SubmitButton name='Apply' />
                </div>
              </form>
            </div>
          </div>
        )}
        {showImportModal && (<Importdoc show={showImportModal} onClose={closeModal} getData={getData} />)}
      </div>
    </>
  );
}

export default AgentIndex;
